<template>
  <div>
    <v-sheet elevation="2" color="#57bc90" style="min-height: 70vh">
      <v-col cols="12" md="12" sm="12">
        <div v-if="scoring.data">
          <v-data-table
            :headers="computedHeader"
            :items="scoring.data"
            class="elevation-1"
            hide-default-footer
            sort-by="DateTime"
            sort-desc
            mobile-breakpoint="0"
          >
            <!-- Date -->
            <template v-slot:item.DateTime="{ item }">
              <p class="blue--text">{{ item.DateTime | IsoToIst }}</p>
            </template>
            <!-- Date -->

            <!-- points -->
            <template v-slot:item.FantasyPointsDraftKings="{ item }">
              <p v-if="operator == 'FanDuel'" class="body-2">
                {{ item.FantasyPointsFanDuel }}
              </p>

              <p v-if="operator == 'DraftKings'" class="body-2">
                {{ item.FantasyPointsDraftKings }}
              </p>
            </template>
            <!-- points -->

            <!-- salary -->
            <template v-slot:item.DraftKingsSalary="{ item }">
              <p v-if="operator === 'FanDuel'" class="body-2 green--text">
                ${{ item.FanDuelSalary }}
              </p>

              <p v-if="operator === 'DraftKings'" class="body-2 green--text">
                $ {{ item.DraftKingsSalary }}
              </p>
            </template>
            <!-- salary -->

            <!--$ per pts -->
            <template v-slot:item.DepthChartOrder="{ item }">
              <p v-if="operator === 'FanDuel'" class="body-2">
                {{ (item.FanDuelSalary / item.FantasyPointsFanDuel) >> 0 }}
              </p>

              <p v-if="operator === 'DraftKings'" class="body-2">
                {{
                  (item.DraftKingsSalary / item.FantasyPointsDraftKings) >> 0
                }}
              </p>
            </template>
            <!-- $ per pts -->
          </v-data-table>
        </div>
      </v-col>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "Mlbscoring",
  props: {
    scoring: {
      type: [Array, Object],
      default: () => [],
    },
    Position: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    computedHeader() {
      if (this.scoring.data.length > 0) {
        if (this.Position.position.includes("P")) {
          return this.headers.filter((item) => {
            return item.text !== "Bats";
          });
        } else {
          return this.headers;
        }
      }
    },
  },
  data() {
    return {
      operator: localStorage.getItem("gameOperator"),
      headers: [
        {
          text: "Date",
          value: "DateTime",
        },
        {
          text: "Opponent",
          value: "Opponent",
        },
        {
          text: "Bats",
          value: "AtBats",
        },
        {
          text: "Fantasy Points",
          value: "FantasyPointsDraftKings",
          sortable: false,
        },
        { text: "Salary", value: "DraftKingsSalary" },
        // { text: 'Minutes', value: 'minutes' },
        { text: "$ Per Point", value: "DepthChartOrder" },
      ],
    };
  },
};
</script>

<style scoped></style>
